import React from 'react';
type Step = {
  title: string;
  body: string;
};
type StepFlowProps = {
  steps: Step[];
  layout?: 'grid' | 'list';
};
export function StepFlow({
  steps,
  layout = 'grid'
}: StepFlowProps) {
  if (layout === 'list') {
    return <ol className="mt-12 border-t border-line md:mt-14" data-id="element-83" data-mp="2s699zm6d8ckn">
        {steps.map((step, index) => <li key={step.title} className="grid gap-2 border-b border-line py-7 md:grid-cols-12 md:gap-8 md:py-10" data-id="element-84" data-mp="2n40dwgy74ueb" data-mpi={index}>
            <span className="font-display text-[13px] tracking-[0.14em] text-navy md:col-span-2 md:text-mist" data-id="element-85" data-mp="2w6jdms6oqqwc">
              {String(index + 1).padStart(2, '0')}
            </span>
            <h3 className="font-display text-[22px] font-medium leading-tight tracking-tight text-ink md:col-span-5 md:text-[28px]" data-id="element-86" data-mp="3ax0dw87l3arn">
              {step.title}
            </h3>
            <p className="max-w-prose text-[15.5px] leading-relaxed text-graphite md:col-span-5 md:text-[16px]" data-id="element-87" data-mp="3jw403l21s6ad">
              {step.body}
            </p>
          </li>)}
      </ol>;
  }
  return <ol className="mt-12 grid gap-px overflow-hidden rounded-sm bg-line sm:grid-cols-2 md:mt-14 lg:grid-cols-4" data-id="element-88" data-mp="12q25aggspxr5">
      {steps.map((step, index) => <li key={step.title} className="bg-paper p-7 sm:p-8 md:p-9" data-id="element-89" data-mp="1boe1cy0flnqz" data-mpi={index}>
          <div className="flex items-center gap-3" data-id="element-90" data-mp="1gnqprn6yb2vo">
            <span className="font-display text-[13px] tracking-[0.14em] text-navy" data-id="element-91" data-mp="1gpbjxbpcsjt0">
              {String(index + 1).padStart(2, '0')}
            </span>
            <span aria-hidden="true" className="h-px flex-1 bg-line" data-id="element-92" data-mp="1po6rar44vzxw" />
          </div>
          <h3 className="mt-6 font-display text-[21px] font-medium tracking-tight text-ink md:mt-7 md:text-[22px]" data-id="element-93" data-mp="1uf58dswy5227">
            {step.title}
          </h3>
          <p className="mt-3 text-[15px] leading-relaxed text-graphite" data-id="element-94" data-mp="1zdqa5wrujtsr">{step.body}</p>
        </li>)}
    </ol>;
}